<div
  class="gallery dark"
  [class.compact]="compact"
  [class.dark-background]="darkBackground"
  [class.blurred]="gallery.password_enabled && showPasswordProtected"
  [class.has-asset]="!!gallery.teaser?.uuid"
  #galleryItem
  appInferredHover="gallery-{{ gallery.id }}"
>
  <div class="background"></div>
  <div class="asset-container" *ngIf="gallery.teaser?.uuid">
    <img
      [src]="gallery | galleryTeaserUrl : 600"
      [style.object-position]="gallery.teaser.uuid === gallery.cover.uuid ? gallery.cover.position : undefined"
      alt=""
      loading="lazy"
      [attr.data-picflow-hide]="true"
      #el
    />
  </div>
  <div class="gallery-asset-empty" alt="" *ngIf="!gallery.teaser?.uuid">
    <app-svg src="/assets/icons/96/image-dotted.svg"></app-svg>
  </div>
  <div class="gallery-interactions">
    <ng-content select="[contentOnHover]"></ng-content>
  </div>
  <ng-content select="[contentAlways]"></ng-content>
  <div class="gallery-info" *ngIf="isInView">
    <h3>{{ gallery.name || gallery.title || 'Untitled' }}</h3>
    <div class="meta" *ngIf="!(gallery.password_enabled && showPasswordProtected)">
      <span *ngIf="gallery['parent_gallery_id']">Sub-Gallery ⋅ </span>
      <span
        >{{ assetCount }} <span *ngIf="assetCount === 1">Asset</span><span *ngIf="assetCount !== 1">Assets</span></span
      >
      <span *ngIf="!gallery['parent_gallery_id']"> ⋅ {{ gallery.last_changed_at * 1000 | relativeTime }}</span>
    </div>
    <div class="meta" *ngIf="gallery.password_enabled && showPasswordProtected">
      <span>Protected Gallery</span>
    </div>
  </div>
  <div *ngIf="gallery.password_enabled && showPasswordProtected" class="lock">
    <app-svg src="/assets/icons/lock.svg"></app-svg>
  </div>
  <div class="gallery-background"></div>
</div>
